import { useState } from 'react';
import { categories } from '@/mocks/categories';
import { Link } from 'react-router-dom';

export default function CategoryTabs({ activeSlug }: { activeSlug?: string }) {
  const [active, setActive] = useState(activeSlug || categories[0].slug);

  return (
    <div className="flex items-center gap-2 overflow-x-auto pb-2 flex-wrap">
      {categories.map((cat) => (
        <Link
          key={cat.slug}
          to={`/category/${cat.slug}`}
          onClick={() => setActive(cat.slug)}
          className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap cursor-pointer transition-all duration-200 ${
            (activeSlug || active) === cat.slug
              ? 'bg-primary-500 text-background-50'
              : 'bg-background-100 text-foreground-600 hover:bg-background-200 hover:text-foreground-800'
          }`}
        >
          <i className={`${cat.icon} text-sm`}></i>
          {cat.name}
        </Link>
      ))}
    </div>
  );
}